export const ZIPCodePattern = /^[0-9]{4,5}$/;
